export default __webpack_public_path__ + "static/media/method2.ea7c7490.png";